import React, { useState} from "react";
import axios from "axios";
import { parseJwt } from "../../utils/helper";

const Profile = ({title}) => {
  document.title = title;


  const token = localStorage.getItem('token');
  const decodedToken = parseJwt(token);
  const userId = decodedToken?.id; 


  const [formData, setFormData] = useState({
    userId: userId,  
    currentPassword: "", // For verifying the current password
    newPassword: "", 
  });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/api/user/put`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMessage(response.data.message);
    } catch (err) {
      setMessage(err.response?.data?.message || 'An error occurred');
    }
  };

 const reload = () => {
  window.location.reload()
 };
  return (
    <div className="bg-yellow-50 h-[calc(100vh-64px)] flex items-center justify-center">
      <div className="p-12 md:w-1/2 w-full bg-white shadow-lg rounded-lg">
        <h2 className="text-2xl font-bold text-gray-800 mb-2 text-center">
          Change Password
        </h2>
        {message && (
          <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative my-4" role="alert">
          <strong className="font-bold">{message} !</strong>
          <button onClick={reload}><i className="absolute top-0 bottom-0 right-0 px-4 py-3 fas fa-close text-base" ></i></button>
        </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-6">
          
          {/* Previous Password */}
          <div>
            <label htmlFor="currentPassword" className="block text-sm font-medium text-gray-700">
              Current Password
            </label>
            <input
              type="password"
              id="currentPassword"
              name="currentPassword"
              value={formData.currentPassword}
              onChange={handleChange}
              className="mt-1 p-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm"
              placeholder="Enter your current password"
            />
          </div>

          {/* New Password */}
          <div>
            <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700">
              New Password
            </label>
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleChange}
              className="mt-1 p-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm"
              placeholder="Enter a new password"
            />
          </div>

          {/* Submit Button */}
          <div className="text-center">
            <button
              type="submit"
              className="w-full px-4 py-2 bg-yellow-500 text-white rounded-md hover:bg-yellow-600 transition"
            >
              Update Password
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Profile;
